webpackJsonp([35783957827783],{

/***/ 188:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PortfolioItem = function PortfolioItem(props) {
		return _react2.default.createElement(
			'div',
			{ className: 'portfolio-item' },
			_react2.default.createElement(
				_gatsbyLink2.default,
				{ to: props.slug },
				_react2.default.createElement(
					'div',
					{ className: 'imgcontainer' },
					_react2.default.createElement('img', { src: props.img })
				)
			),
			_react2.default.createElement(
				'h2',
				{ className: 'title' },
				_react2.default.createElement(
					_gatsbyLink2.default,
					{ to: props.slug },
					props.children
				)
			)
		);
	};
	
	var IndexPage = function IndexPage() {
		return _react2.default.createElement(
			'div',
			{ id: 'top', className: 'home' },
			_react2.default.createElement(
				'header',
				{ className: 'heikki-image heikki2' },
				_react2.default.createElement(
					'div',
					{ className: 'info' },
					_react2.default.createElement(
						'h1',
						{ className: 'hugetitle' },
						'Hello!'
					),
					_react2.default.createElement(
						'h3',
						null,
						'I\'m Heikki.'
					)
				)
			),
			_react2.default.createElement(
				'section',
				{ className: 'whatido' },
				_react2.default.createElement(
					'div',
					null,
					'Visual Design | UI Design | Web Design'
				)
			),
			_react2.default.createElement(
				'div',
				{ className: 'portfolioarea' },
				_react2.default.createElement(
					PortfolioItem,
					{
						slug: 'tribe',
						img: '/img/tribe-1.jpg'
					},
					'Tribe Tampere'
				),
				_react2.default.createElement(
					PortfolioItem,
					{
						slug: 'creativitysquads',
						img: '/img/creativitysquads-1.jpg'
					},
					'Creativity Squads'
				),
				_react2.default.createElement(
					PortfolioItem,
					{
						slug: 'socnd',
						img: '/img/socnd-1.jpg'
					},
					'School of Creativity and Design'
				),
				_react2.default.createElement(
					PortfolioItem,
					{
						slug: 'highpeak',
						img: '/img/highpeak-1.jpg'
					},
					'High Peak Ideakuvasto'
				),
				_react2.default.createElement(
					PortfolioItem,
					{
						slug: 'idrive',
						img: '/img/idrive-1.jpg'
					},
					'Nokian autokoulu I Drive'
				),
				_react2.default.createElement(
					PortfolioItem,
					{
						slug: 'oneo',
						img: '/img/oneo-1.jpg'
					},
					'One-o Design'
				),
				_react2.default.createElement(
					PortfolioItem,
					{
						slug: 'logos',
						img: '/img/logos-1.jpg'
					},
					'Logos'
				)
			),
			_react2.default.createElement('div', { className: 'clearfix' })
		);
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-9f6ce7cc71f4b63625ce.js